import {
  RiBrushLine,
  RiCodeSSlashLine,
  RiSearchLine,
  RiMegaphoneLine,
  RiInstagramLine,
  RiBarChartBoxLine,
} from "@remixicon/react"

export default function CharlestonServices() {
  const services = [
    {
      icon: RiBrushLine,
      title: "Branding & Identity",
      description: "Stand out in Charleston's competitive market with a memorable brand that resonates with locals.",
      features: ["Logo Design", "Brand Guidelines", "Visual Identity", "Brand Strategy"],
    },
    {
      icon: RiCodeSSlashLine,
      title: "Web Development",
      description: "Beautiful, fast, and mobile responsive websites that convert Charleston customers into loyal clients.",
      features: ["Custom Websites", "Ecommerce", "Mobile Optimization", "Maintenance"],
    },
    {
      icon: RiSearchLine,
      title: "SEO Optimization",
      description: "Rank higher on Google for Charleston area searches and attract customers actively looking for your services.",
      features: ["Local SEO", "Google My Business", "Keyword Research", "Content Strategy"],
    },
    {
      icon: RiInstagramLine,
      title: "Social Media Management",
      description: "Engage with the Charleston community through strategic social media content and management.",
      features: ["Content Creation", "Community Management", "Analytics", "Growth Strategy"],
    },
    {
      icon: RiMegaphoneLine,
      title: "Digital Advertising",
      description: "Targeted ad campaigns on Google, Facebook, and Instagram to reach your ideal Charleston customers.",
      features: ["Google Ads", "Facebook Ads", "Instagram Ads", "Retargeting"],
    },
    {
      icon: RiBarChartBoxLine,
      title: "Analytics & Reporting",
      description: "Data driven insights to understand your customers and optimize your marketing investments.",
      features: ["Traffic Analysis", "Conversion Tracking", "Monthly Reports", "Strategy Optimization"],
    },
  ]

  return (
    <section
      aria-label="Our Services"
      id="services"
      className="relative mx-auto max-w-7xl px-4 scroll-my-24"
    >
      <div className="text-center mb-16">
        <h2 className="relative inline-block text-lg font-semibold tracking-tight text-[#003566]">
          Our Services
          <div className="absolute top-1 -left-[8px] h-5 w-[3px] rounded-r-sm bg-[#003566]" />
        </h2>
        <p className="mt-4 text-4xl font-semibold tracking-tighter text-balance text-gray-900 md:text-5xl">
          Everything Your Business Needs to Thrive Online
        </p>
        <p className="mt-4 text-lg text-balance text-gray-700 max-w-3xl mx-auto">
          From branding to digital marketing, we offer comprehensive services designed specifically for Charleston small businesses.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {services.map((service, index) => {
          const Icon = service.icon
          return (
            <div
              key={index}
              className="group relative overflow-hidden rounded-2xl border border-gray-200 bg-white p-8 shadow-sm transition-all duration-300 hover:shadow-lg hover:border-[#003566]/20"
            >
              <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-[#003566]/5 to-transparent rounded-bl-full transition-all duration-300 group-hover:scale-110" />

              <div className="relative">
                <div className="inline-flex items-center justify-center rounded-xl bg-gradient-to-br from-[#003566] to-[#000814] p-3 shadow-lg">
                  <Icon className="size-6 text-white" />
                </div>

                <h3 className="mt-6 text-xl font-semibold text-gray-900">
                  {service.title}
                </h3>
                <p className="mt-3 text-gray-600 leading-relaxed">
                  {service.description}
                </p>

                <ul className="mt-6 space-y-2">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center text-sm text-gray-700">
                      <div className="mr-2 h-1.5 w-1.5 rounded-full bg-[#003566]" />
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          )
        })}
      </div>
    </section>
  )
}
